// SLY · Product: gallery thumbs, variant picker (price, stock, image, URL, waitlist), quantity, add to bag, sticky bar.
document.querySelectorAll('[data-sly-product]').forEach(sec => {
  const product = JSON.parse(sec.querySelector('[data-product-json]').textContent);
  const cfg = document.querySelector('[data-sly-cart-config]');
  const cur = cfg ? JSON.parse(cfg.textContent) : { currency: '', decimals: 2 };
  const money = c => `<span class="sly-cur">${cur.currency}</span> <span class=money>${(c / 100).toFixed(cur.decimals)}</span>`;  // span.money: see sly-money.liquid
  const sel = [...(new URLSearchParams(location.search).get('variant')
    ? (product.variants.find(v => v.id == new URLSearchParams(location.search).get('variant')) || product.variants[0]).options
    : (product.variants.find(v => v.available) || product.variants[0]).options)];
  let variant = null, qty = 1;
  // pre-order: until the launch time nothing can be added; the page flips to buying by itself at launch
  const launch = +sec.dataset.launch || 0;
  const prelaunch = () => launch * 1000 > Date.now();
  const box = sec.querySelector('[data-launch-box]');
  if (prelaunch()) {
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const left = Math.max(0, launch * 1000 - Date.now());
      if (!left) return location.reload();
      if (box) {
        const t = Math.floor(left / 1000);
        box.querySelector('[data-d]').textContent = Math.floor(t / 86400);
        box.querySelector('[data-h]').textContent = pad(Math.floor(t % 86400 / 3600));
        box.querySelector('[data-m]').textContent = pad(Math.floor(t % 3600 / 60));
        box.querySelector('[data-s]').textContent = pad(t % 60);
      }
      setTimeout(tick, 1000);
    };
    tick();
  }

  const show = id => {
    sec.querySelectorAll('[data-slide]').forEach(sl => sl.hidden = sl.dataset.slide != id);
    sec.querySelectorAll('[data-thumbs] button').forEach(b => b.setAttribute('aria-current', b.dataset.media == id));
  };

  function update() {
    variant = product.variants.find(v => v.options.every((o, i) => o === sel[i])) || variant || product.variants[0];
    sec.querySelectorAll('[data-opt]').forEach(fs => {
      const i = +fs.dataset.opt;
      fs.querySelector('[data-opt-val]').textContent = sel[i];
      fs.querySelectorAll('[data-val]').forEach(b => {
        b.setAttribute('aria-pressed', b.dataset.val === sel[i]);
        const t = [...sel]; t[i] = b.dataset.val;
        const v = product.variants.find(x => x.options.every((o, j) => o === t[j]));
        b.classList.toggle('is-out', !v || !v.available);
      });
    });
    const sale = variant.compare_at_price > variant.price;
    sec.querySelectorAll('[data-price]').forEach(p => p.innerHTML = `<span class="sly-price${sale ? ' sly-price--sale' : ''}">${money(variant.price)}${sale ? `<s>${money(variant.compare_at_price)}</s>` : ''}</span>`);
    sec.querySelectorAll('[data-sticky-price]').forEach(p => p.innerHTML = money(variant.price));
    sec.querySelectorAll('[data-add]').forEach(b => { b.disabled = !variant.available; b.textContent = variant.available ? (b.closest('[data-buy]') ? b.dataset.label || b.textContent.replace('Sold out', 'Add to bag') : 'Add to bag') : 'Sold out'; });
    sec.querySelectorAll('[data-waitlist]').forEach(w => w.hidden = variant.available && !prelaunch());
    sec.querySelectorAll('[data-wait-note]').forEach(n => n.value = `Waitlist request for: ${product.title} (${variant.title})`);
    if (variant.featured_media) show(variant.featured_media.id);
    if (product.variants.length > 1) history.replaceState(null, '', `${location.pathname}?variant=${variant.id}`);
  }

  sec.querySelectorAll('[data-add]').forEach(b => { if (b.closest('[data-buy]')) b.dataset.label = b.textContent.trim() === 'Sold out' ? 'Add to bag' : b.textContent.trim(); });
  sec.addEventListener('click', e => {
    const t = e.target.closest('[data-thumbs] button'); if (t) return show(t.dataset.media);
    const o = e.target.closest('[data-val]');
    if (o) { sel[+o.closest('[data-opt]').dataset.opt] = o.dataset.val; return update(); }
    const q = e.target.closest('[data-q]');
    if (q) { qty = Math.max(1, qty + +q.dataset.q); sec.querySelectorAll('[data-qty]').forEach(x => x.textContent = qty); return; }
    if (e.target.closest('[data-add]') && variant.available && !prelaunch() && window.SLYCart) SLYCart.add([{ id: variant.id, quantity: qty }]);
  });

  const bar = sec.querySelector('[data-sticky]'), buy = sec.querySelector('[data-buy]');
  if (bar && buy) addEventListener('scroll', () => bar.classList.toggle('on', buy.getBoundingClientRect().bottom < 0), { passive: true });
  update();
});
